import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../Hooks/redux";
import { selectIsAuthenticated } from "../Redux/AuthRedux";

/**
 * Route guard — redirects unauthenticated users to /login.
 * Wrap protected <Route> groups with this as a layout route.
 */
export default function ProtectedRoute() {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/start" replace />;
  }

  return <Outlet />;
}
